import React from 'react'
import { Breadcrumb } from '../../Components'
import { Box, Typography } from '@material-ui/core'
import { useStyles } from './styles'

const News = () => {
  const classes = useStyles()
  return (
    <>
      <Breadcrumb />
      <Box className={classes.container}>
        <Typography className={classes.title}>News</Typography>
        <Typography className={classes.subTitle}>Stay updated with the latest Grid Services enhancements, technical releases, and system updates.</Typography>
      </Box>
    </>
  )
}

export default News